module.exports = __webpack_public_path__ + "static/media/payment-template.7655e9fa.xlsx";